import { FC, useState } from 'react';
import { Button } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import NewPay from '../NewPay';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import './styles.scss';

interface IProps {
  order_id: number;
  isStripeId: boolean;
}

const PaymentsButtons: FC<IProps> = ({ order_id, isStripeId }) => {
  const { role } = useTypedSelector(state => state.auth);
  const [open, setOpen] = useState('');

  return (
    <>
      <div className='payment-buttons'>
        <Button className='payment-buttons__add' onClick={() => setOpen('add')}>
          <AddCircleOutlineIcon />
          <span>add Manual Payment</span>
        </Button>
        {isStripeId || role === 'admin' ? (
          <Button className='payment-buttons__get' onClick={() => setOpen('stripe')}>
            <AddCircleOutlineIcon />
            <span>get Split Payment</span>
          </Button>
        ) : (
          <></>
        )}
      </div>
      <NewPay
        orderId={order_id}
        isStripeId={isStripeId}
        handleClose={() => setOpen('')}
        open={!!open.length}
        type={open}
      />
    </>
  );
};

export default PaymentsButtons;
